import * as VueGoogleMaps from 'vue2-google-maps-withscopedautocomp'

const component = VueGoogleMaps;
const options = {
  load: {
    key: 'AIzaSyCu1N9tNE8mEh_u4yI3SCOn3M_gV3CgL5E',
    libraries: 'places',
  },
  installComponents: true,
};

export {component, options}